import { createSlice } from "@reduxjs/toolkit";
// import { singleCompany } from "./companyThunk";
const initialState = {
  companies: [],
  companyTypes: [],
  singleCompany:{},
  selectedCompany: null,
  isLoading: false,
  error: null,
};
const companySlice = createSlice({
  name: "company",
  initialState,
  reducers: {
    setCompanies: (state, action) => {
      state.companies = action.payload;
    },
    setCompanyTypes: (state, action) => {
      state.companyTypes = action.payload;
    },
    addCompany: (state, action) => {
      state.companies.push(action.payload);
    },
    updateCompany: (state, action) => {
            const index = state.companies.findIndex(
              (item) => item.id === action.payload.id
            );
            if (index !== -1) {
              state.companies[index] = action.payload;
            }
          },
    removeCompany: (state, action) => {
      state.companies = state.companies.filter(
        (company) => company.id !== action.payload
      );
    },
    setSingleCompany: (state, action) => {
      state.singleCompany = action.payload;
    },
    
    setSelectedCompany: (state, action) => {
      state.selectedCompany = action.payload;
      // For backward compatibility, still maintain localStorage
      localStorage.setItem("company_id", action.payload?.id || "");
    },
    clearSelectedCompany: (state) => {
      state.selectedCompany = null;
      localStorage.removeItem("company_id");
    },
    // API request states
    apiRequestStart: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    apiRequestSuccess: (state) => {
      state.isLoading = false;
    },
    apiRequestFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});
// Export actions
export const {
  setCompanies,
  setCompanyTypes,
  addCompany,
  removeCompany,
  setSelectedCompany,
  clearSelectedCompany,
  apiRequestStart,
  apiRequestSuccess,
  apiRequestFailure,
  setSingleCompany, // Updated name
} = companySlice.actions;
// Export selectors
export const selectCompanies = (state) => state.company.companies;
export const selectCompanyTypes = (state) => state.company.companyTypes;
export const selectSelectedCompany = (state) => state.company.selectedCompany;
export const selectIsLoading = (state) => state.company.isLoading;
export const selectSingleCompany =(state) => state.company.singleCompany
export const selectError = (state) => state.company.error;
// Export reducer
export default companySlice.reducer;